module.exports = __webpack_public_path__ + "static/media/3-6.14ad51d7.mp3";